import React from 'react';
import { Mail, Phone, Youtube, Facebook, Instagram, Linkedin } from 'lucide-react';
import logoWhite from '../assets/images/logo-white.png';

function Footer() {
  return (
    <footer className="bg-black text-white py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pb-8">
          <div>
            <img src={logoWhite} alt="VernPOS Logo" className="h-8 mb-6" />
            <p className="text-gray-400 mb-4">
              Lot 109-113, Jalan USJ 21/10, 47630 Subang Jaya, Selangor
              <br />
              Darul Ehsan, Malaysia.
            </p>
            <div className="flex items-center mb-3">
              <Mail size={16} className="text-gray-400 mr-2" />
              <a
                href="mailto:info@vernpos.my"
                className="text-gray-400 hover:text-white"
              >
                info@vernpos.my
              </a>
            </div>
            <div className="flex items-center mb-6">
              <Phone size={16} className="text-gray-400 mr-2" />
              <a
                href="tel:+601700816729"
                className="text-gray-400 hover:text-white"
              >
                +60 1700 81 6729
              </a>
            </div>

            <div className="flex space-x-3 hidden">
              <a
                href="#1"
                className="bg-gray-800 hover:bg-gray-700 w-8 h-8 rounded-full flex items-center justify-center"
              >
                <Youtube size={16} className="text-white" />
              </a>
              <a
                href="#2"
                className="bg-gray-800 hover:bg-gray-700 w-8 h-8 rounded-full flex items-center justify-center"
              >
                <Facebook size={16} className="text-white" />
              </a>
              <a
                href="#3"
                className="bg-gray-800 hover:bg-gray-700 w-8 h-8 rounded-full flex items-center justify-center"
              >
                <Instagram size={16} className="text-white" />
              </a>
              <a
                href="#4"
                className="bg-gray-800 hover:bg-gray-700 w-8 h-8 rounded-full flex items-center justify-center"
              >
                <Linkedin size={16} className="text-white" />
              </a>
            </div>
          </div>

          <div className="bg-black text-white px-4 py-10">
            <div className="max-w-6xl mx-auto">
              {/* Nav Row */}
              <nav className="flex flex-wrap md:flex-nowrap justify-start gap-6 mb-6">
                <a href="/" className="text-white hover:text-gray-400">
                  Home
                </a>
                <a href="/about-us" className="text-white hover:text-gray-400">
                  About Us
                </a>
                <a href="/products" className="text-white hover:text-gray-400">
                  Products
                </a>
                <a
                  href="/case-study"
                  className="text-white hover:text-gray-400"
                >
                  Case Study
                </a>
                <a
                  href="/contact-us"
                  className="text-white hover:text-gray-400"
                >
                  Contact
                </a>
              </nav>

              {/* Divider Line */}
              <div className="border-t border-white/20 mb-6"></div>

              {/* Paragraph */}
              <p className="text-sm text-white/80 leading-relaxed">
                VernPOS is your trusted, all-in-one POS solution designed to
                streamline transactions, manage inventory in real-time, and
                boost customer satisfaction. Whether you're in retail, F&B, or
                service industries, VernPOS empowers your business with seamless
                payment options, detailed reporting, and easy-to-use tools that
                help you operate more efficiently and grow your revenue.
                Discover how VernPOS can transform your business today.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0 flex">
            ©{new Date().getFullYear()}&nbsp;,&nbsp;{" "}
            <div style={{ color: "#E6ACA8" }}>VernPos &nbsp;</div> | All right
            reserved.
          </div>
          <div className="flex space-x-4">
            <a
              href="#11"
              className="text-gray-400 hover:text-white text-sm hidden"
            >
              Terms of Service
            </a>
            <span className="text-gray-600">|</span>
            <a
              href="/privacy-policy"
              className="text-gray-400 hover:text-white text-sm"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;